module.exports = __webpack_public_path__ + "static/media/logo-fitbit-icon.9f3ed44a.png";